import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CanalVenda } from '../../../../home/common/canais-venda/domain/canal-venda';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-novo-canal-venda-multi-select',
  templateUrl: './novo-canal-venda-multi-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoCanalVendaMultiSelectComponent),
      multi: true
    }
  ]
})
export class NovoCanalVendaMultiSelectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() idsCanaisVendas: number[] = [];
  @Input() variante: 'filtro' | undefined;
  @Input() settings: Partial<IMultiSelectSettings> = {};

  @Output() changed = new EventEmitter<number[]>();

  options: IOption[] = [];
  defaultSettings: IMultiSelectSettings = {
    placeholder: 'Selecione os canais de venda',
    singular: 'Canais de Venda',
    plural: 'Canais de Venda',
    searchEmptyResultMessage: 'Nenhum canal de venda encontrado',
    showFooter: false
  };

  ngOnInit() {
    this.settings = { ...this.defaultSettings, ...this.settings };
    this.options = CanalVenda.getAll().map(canal => ({
      id: canal.id,
      label: canal.nome,
      isChecked: false
    }));
  }

  protected updateValue(newValue: number[] | null): void {
    this.idsCanaisVendas = newValue || [];
  }

  onSelectionChange(): void {
    this.emitChange(this.idsCanaisVendas);
  }

  onSearch(): void {
    this.changed.emit(this.idsCanaisVendas);
  }
}
